import Flx from "../../layout/Flx";
// src/components/LoanFilesTable/hooks/useColumnDefs.js
import {
  CommentOutlined,
  HouseOutlined,
  MapsHomeWorkOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import { useMemo } from "react";
import useAssociationUtils from "../../associations/hooks/useAssociationUtils";
import { useSelector } from "react-redux";
import { size } from "lodash";
import joinArrayOfStrings from "../../../_src_shared/utils/functions/joinArrayOfStrings";
import { htmlStringToText } from "../../../_src_shared/utils/functions/htmlStringToText";
import { Box, Tooltip, Typography } from "@mui/material";
import Txt from "../../typography/Txt";
import { addressLabel } from "../../../_src_shared/utils/functions/addressLabel";

const CellRendererLoanFileAssociations = (params) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const docId = useMemo(() => params?.data?._id, [params?.data?._id]);
  const {
    getLoanDocumentAssociationSummary,
    getAssociatableObjectsByLoanDocumentId,
  } = useAssociationUtils();

  // const updatedByUserEmail =
  //   params?.data?.documentStatusUpdateBy || params?.data?.updatedBy;

  const summary = useMemo(() => {
    return getLoanDocumentAssociationSummary(loanDrilldown, docId, {
      returnType: "objects",
    });
  }, [loanDrilldown, docId, getLoanDocumentAssociationSummary]);

  // const summaryTotalCount = useMemo(
  //   () => summary?.totalCount,
  //   [summary?.totalCount]
  // );
  const summaryData = useMemo(
    () => summary?.categorized,
    [summary?.categorized]
  );

  const associatedBorrowersData = useMemo(() => {
    return getAssociatableObjectsByLoanDocumentId(
      loanDrilldown,
      "borrowers",
      docId
    );
  }, [loanDrilldown, docId, getAssociatableObjectsByLoanDocumentId]);

  // const associatedPropertiesData = useMemo(() => {
  //   return getAssociatableObjectsByLoanDocumentId(
  //     loanDrilldown,
  //     "subjectProperties",
  //     docId
  //   );
  // }, [loanDrilldown, docId, getAssociatableObjectsByLoanDocumentId]);

  // const tempAssociatedEntityId = useMemo(() => {
  //   return loanDrilldown?.borrowerEntity?._id;
  // }, [loanDrilldown?.borrowerEntity?._id]);
  // const match = tempAssociatedEntityId === docId;
  // console.log("summary", summaryData);
  // console.log("summary", { summaryData, tempAssociatedEntityId, docId, match });
  return (
    <Flx gap={1.2} ac sx={{ height: "100%" }}>
      <AssociationIcon
        icon={<CommentOutlined className="thin" />}
        title={"Comment Associations"}
        count={size(summaryData?.comments)}
        titleContent={joinArrayOfStrings(
          summaryData?.comments?.map((comment) =>
            htmlStringToText(comment?.htmlString)
          )
        )}
      />
      <AssociationIcon
        icon={<PersonOutlineOutlined className="thin" />}
        title={"Borrower Associations"}
        count={size(summaryData?.borrowers)}
        titleContent={joinArrayOfStrings(
          associatedBorrowersData?.map((b) => `${b.firstName} ${b.lastName}`)
        )}
      />
      <AssociationIcon
        icon={<HouseOutlined className="thin" />}
        title={"Property Associations"}
        count={size(summaryData?.subjectProperties)}
        titleContent={joinArrayOfStrings(
          summaryData?.subjectProperties?.map(
            (b) => addressLabel(b.address) || "Unknown Address"
          )
        )}
      />
      {/* {tempAssociatedEntityId === docId && (
        <AssociationIcon
          icon={<MapsHomeWorkOutlined className="thin" />}
          count={1}
          title={"Entity Associations"}
          titleContent={tempAssociatedEntityId?.name}
        />
      )} */}
      <AssociationIcon
        icon={<MapsHomeWorkOutlined className="thin" />}
        title={"Entity Associations"}
        count={size(summaryData?.borrowerEntity)}
        titleContent={joinArrayOfStrings(
          summaryData?.borrowerEntity?.map(
            (b) => b.entityName || "Unknown Address"
          )
        )}
      />
    </Flx>
  );
};
const AssociationIcon = ({ icon, title, titleContent, count, sx }) => {
  if (count <= 0) {
    return null;
  }
  return (
    <Tooltip
      title={
        <Flx column>
          <Txt bold sx={{ color: "#ffffff" }}>
            {title} ({count})
          </Txt>
          <Txt sx={{ color: "#ffffff" }}>{titleContent}</Txt>
        </Flx>
      }
    >
      <Box
        sx={{
          gap: "2px",
          display: "flex",
          alignItems: "center",
          ".MuiSvgIcon-root": {
            fontSize: "14px",
          },
          ...sx,
        }}
      >
        {icon}
        <Typography sx={{ fontSize: "11px", opacity: 0.7 }}>{count}</Typography>
      </Box>
    </Tooltip>
  );
};

export default CellRendererLoanFileAssociations;
